export const ProductStatus = {
	DRAFT: 0,
	ACTIVE: 1,
}

export const ProductBadgeEnum: Record<string, string> = {
	draft: 'orange',
	active: 'green',
}

export const ProductStatusEnum: Record<string, string> = {
	draft: '下書き',
	active: 'アクティブ',
}
